import { contestActionTypes } from "./contest.actionTypes";
const initialState = {
  liveData: [],
  closeData: [],
  eventsData: [],
  contestCardsLoading: false,
  contestEventsLoading: false,
  isContestVisible: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case contestActionTypes.SET_CONTEST_BALANCE_LOADING: {
      return { ...state, contestBalanceloading: true };
    }
    case contestActionTypes.SET_CONTEST_BALANCE_SUCCESS: {
      return {
        ...state,
        contestBalanceloading: false,
        contestBalanceData: action.payload,
      };
    }
    case contestActionTypes.SET_CONTEST_BALANCE_ERROR: {
      return {
        ...state,
        contestBalanceloading: false,
        contestBalanceError: action.payload,
      };
    }
    case contestActionTypes.CONTEST_CLOSED_LOADING: {
      return { ...state, contestCardsLoading: true };
    }
    case contestActionTypes.CONTEST_CLOSED_SUCCESS: {
      return {
        ...state,
        contestCardsLoading: false,
        closeData: action.payload,
      };
    }
    case contestActionTypes.CONTEST_CLOSED_ERROR: {
      return {
        ...state,
        contestCardsLoading: false,
        closeErrors: action.payload,
      };
    }
    case contestActionTypes.CONTEST_LIVE_LOADING: {
      return { ...state, contestCardsLoading: true };
    }
    case contestActionTypes.CONTEST_LIVE_SUCCESS: {
      return { ...state, contestCardsLoading: false, liveData: action.payload };
    }
    case contestActionTypes.CONTEST_LIVE_ERROR: {
      return {
        ...state,
        contestCardsLoading: false,
        liveErrors: action.payload,
      };
    }
    case contestActionTypes.CONTEST_EVENT_LOADING: {
      return { ...state, contestEventsLoading: true };
    }
    case contestActionTypes.CONTEST_EVENT_SUCCESS: {
      return {
        ...state,
        contestEventsLoading: false,
        eventsData: action.payload,
      };
    }
    case contestActionTypes.SET_CONTEST_VISIBLE: {
      return { ...state, isContestVisible: true };
    }
    case contestActionTypes.CONTEST_EVENT_ERROR: {
      return {
        ...state,
        contestEventsLoading: false,
        eventErrors: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as contestLeaderboardReducer };
